

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Env from '@/services/env.service';
import GAService from '@/services/ga.service';
import api from "../api/newget"
// declare var AuthBar: any;
@Component({
  components: {
  },
})
export default class Auth extends Vue {

  public menuIsExpanded: boolean = false;
  public routeName: string = '';
  public hideNavFor: string[] = [
    'splash'
  ];

  public showUserProfile: boolean = false;

  get environment() {
    return Env.get('VUE_APP_ENVIRONMENT');
  }

  get showNav() {
    return this.routeName && this.hideNavFor.indexOf(this.routeName) === -1;
  }
  
  get isTransparent() {
    return !this.authToken;
  }

  get authToken() {
    return this.$store.state.auth.authToken;
  }

  get tokenExp() {
    return this.$store.state.auth.tokenExp;
  }

  get isSplash() {
    return this.$route.name === 'splash';
  }

  get isLoggedIn() {
    return this.$store.state.auth.isAuthed;
  }

  get showMaintenance(){
    return this.routeName === 'calculator';
  }

  get isSpecialMode() {
    return Env.get("VUE_APP_NAMESPACE") ? true : false;
  }

  get user() {
    return this.$store.state.auth.user;
  }

  get userName() {
    return this.$store.state.auth.userGivenName + ' ' + this.$store.state.auth.userFamilyName;
  }

  public goToHome() {
    this.$router.push('/info')
  }

  @Watch('$route')
  public onPropertyChanged(value: string, oldValue: string) {
    this.menuIsExpanded = false;
    this.routeName = this.$route.name || '';
  }

  public openFeedback() {
    this.$store.commit('setModal', 'feedback');
  }

  public openAdminModal() {
    this.$store.commit('setModal', 'adminModal');
  }
  
  /**
   * Sets token and token expiry we've got from auth bar.
   * NB: doesn't redirect to eg '/', because this is called every
   * time the auth bar is initialised, ie even if a logged in user
   * refreshes the page. Route handling from logged out -> logged 
   * in is handled in individual views, eg Splash.vue
   */
  private onLogin(tokens: any[]) {
    const siteTokens = tokens.find((t: any) => t.dst === Env.get('VUE_APP_ISSUER'));
    this.$store.dispatch('onLogin', {
      token: siteTokens.token,
      exp: siteTokens.exp || 0
    });

    GAService.setDimension(this.$gtag, 'user_id', siteTokens.sub);

    this.listenForFocus();
  }

  private async onLogout() {
    try{
      const res = await api.get("/logout");
      if (res && res.status === 200) {
        console.log("Logout successful");
        this.$store.dispatch('onLogout');
      } else {
        console.error("Logout failed", res.data.message);
      }
    }catch(e){
      console.error("Error while calling logout API on logout", e);
    }
  }

  private addAuthBar() {
    // AuthBar.render(
    //   {
    //     identServiceUrl: Env.get('VUE_APP_IDENTITY_SERVICE'),
    //     issuer: Env.get('VUE_APP_ISSUER'),
    //     services: [Env.get('VUE_APP_ISSUER')],
    //     providers: ['safe', 'aaa'],
    //     redirectOnLogout: true,
    //     logoImageUrl: '',
    //     logoUrl: '/'
    //   },
    //   '#authBarPlaceholder'
    // );
    // AuthBar.on('login', (tokens: any[]) => {
    //   this.onLogin(tokens);
    // });
    // AuthBar.on('logout', () => {
    //   this.onLogout();
    // });
    // AuthBar.on('expired', (token: any) => {
    //   this.$store.dispatch('onLogout', true);
    // });


  }

  /** 
   * We need the following because...
   * To catch expired tokens, the authlib code has a timeout based on the 
   * token expiry time. On completion of this timeout, the expired event is
   * fired. We do listen for this (see above .on("expired")), but in Chrome inactive tabs
   * kill long running timeouts/intervals. We therefore also want to check
   * for token expiry whenever the page is re-focussed.
   */
  private listenForFocus() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && this.tokenExp) {
        if (Date.now() > (this.tokenExp * 1000)) {
          this.$store.dispatch('onLogout', true);
        }
      }
    });
  }

  private mounted() {
    this.routeName = this.$route.name || '';
    this.addAuthBar();

    const exp: number = localStorage.getItem('tokenExp') ? parseInt(localStorage.getItem('tokenExp') || '0', 10) : 0;
    if (exp && (Date.now() >= (exp * 1000))) {
      this.$store.dispatch('onLogout', true);
    }
  }

  public handleSignOut() {
    this.onLogout();
    this.showUserProfile = false;
  }
}

